export default __webpack_public_path__ + "static/enviameCEO-96b80e2b-ce22b67e5722daa58d24f1900a3dcd02.webp";